import React, { useContext } from "react";
import { IdentityContext } from "@react-beets/identity";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Logo from "../../images/logo-rentbeet.png";
import "./styles.css";

const iconStyles = {
  width: 80,
};

function PropertyManager() {
  const { isAuthenticated } = useContext(IdentityContext);
  const identityUrl =
    process.env.REACT_APP_IDENTITY_URL || "https://auth.rentbeets.com";
  return (
    <Paper className="home">
      <Grid container columnSpacing={{ xs: 1, sm: 2, md: 5 }}>
        <Grid
          item
          xs
          sm={6}
          md={8}
          sx={{
            display: {
              xs: "none",
              sm: "block",
            },
          }}
        >
          <div className="hero" />
        </Grid>
        <Grid item xs={5} sm={6} md={4}>
          <Box
            sx={{
              padding: {
                xs: "2rem",
                sm: " 0 2rem 0 0",
              },
              display: {
                sm: "flex",
              },
              flexDirection: "column",
              justifyContent: "center",
              height: {
                sm: "100%",
              },
            }}
          >
            <Box sx={{ paddingBottom: "1rem" }}>
              <img style={iconStyles} src={Logo} />
            </Box>
            <Typography gutterBottom variant="h1">
              Welcome to RentBeets
            </Typography>
            <Typography gutterBottom variant="p">
              We rent your vacant apartments faster (and cheaper) than the
              competition.
            </Typography>
            <br />
            <Typography gutterBottom variant="p">
              Start listing your units by adding a property. It’s simple and
              easy.
            </Typography>

            <Box pt="1rem">
              {isAuthenticated && (
                <Button
                  component={Link}
                  size="small"
                  to="add-property"
                  variant="contained"
                >
                  Add property
                </Button>
              )}
              {!isAuthenticated && (
                <Button
                  href={`${identityUrl}/Identity/Account/Login`}
                  variant="contained"
                  size="small"
                >
                  Add property
                </Button>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default PropertyManager;
